import { Injectable, effect, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CookieConsentService } from './cookie-consent.service';

@Injectable({ providedIn: 'root' })
export class GtagService {
  private document = inject(DOCUMENT);
  private consentService = inject(CookieConsentService);

  private adsId = '';
  private enabled = false;
  private initialized = false;

  init(adsId: string, enabled: boolean): void {
    this.adsId = adsId;
    this.enabled = enabled;

    if (!enabled || !adsId) return;

    effect(() => {
      const status = this.consentService.$status();
      if (status === 'accepted' && !this.initialized) {
        this._injectScript();
      }
    });
  }

  private _injectScript(): void {
    this.initialized = true;

    const scriptLoader = this.document.createElement('script');
    scriptLoader.async = true;
    scriptLoader.src = `https://www.googletagmanager.com/gtag/js?id=${this.adsId}`;
    this.document.head.appendChild(scriptLoader);

    const scriptConfig = this.document.createElement('script');
    scriptConfig.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${this.adsId}');
    `;
    this.document.head.appendChild(scriptConfig);
  }
}
